// Neumorphic style helpers — local to the Insights page revamp.
// Light-mode-first: neumorphism relies on subtle shadows that don't translate
// well to dark UIs. The Insights page intentionally stays light regardless of
// the app's dark-mode toggle.

export const neumorph = {
  pageBg: "linear-gradient(145deg, #f0f4f8 0%, #e8eef3 100%)",
  pageBgSolid: "#eef2f6",

  raised: {
    bg: "#f5f8fb",
    borderRadius: "20px",
    boxShadow:
      "8px 8px 20px rgba(174,184,200,0.35), -8px -8px 20px rgba(255,255,255,0.95)",
    transition: "all 0.25s ease",
  },

  raisedHover: {
    transform: "translateY(-2px)",
    boxShadow:
      "12px 12px 28px rgba(174,184,200,0.45), -12px -12px 28px rgba(255,255,255,1)",
  },

  pressed: {
    bg: "#eef2f6",
    borderRadius: "20px",
    boxShadow:
      "inset 4px 4px 10px rgba(174,184,200,0.3), inset -4px -4px 10px rgba(255,255,255,0.85)",
  },

  // Smaller raised effect — for KPI tiles and small chips
  raisedSm: {
    bg: "#f5f8fb",
    borderRadius: "14px",
    boxShadow:
      "5px 5px 12px rgba(174,184,200,0.3), -5px -5px 12px rgba(255,255,255,0.9)",
    transition: "all 0.2s ease",
  },

  // Sticky header — flat at top, soft shadow at bottom
  stickyHeader: {
    bg: "rgba(245,248,251,0.92)",
    backdropFilter: "blur(8px)",
    borderBottom: "1px solid rgba(174,184,200,0.15)",
    boxShadow: "0 4px 16px rgba(174,184,200,0.18)",
  },

  // Accent colours from existing app palette
  accentTeal: "#58b6c0",
  accentTealDark: "#04aec1",
  accentGreen: "#58c087",
  accentMint: "#74ebd5",
  accentRed: "#e57373",
  accentOrange: "#ffb74d",

  textMuted: "#7b8896",
  textPrimary: "#2d3748",
}

// Build a "Details" floating button sx — used by BentoCard
export const detailsBtnSx = {
  position: "absolute",
  top: 3,
  right: 3,
  bg: "rgba(245,248,251,0.95)",
  color: neumorph.accentTeal,
  border: "none",
  borderRadius: "10px",
  px: 3,
  py: 1,
  fontSize: "xs",
  fontWeight: "600",
  cursor: "pointer",
  opacity: 0,
  transition: "opacity 0.18s ease, transform 0.18s ease, box-shadow 0.18s ease",
  boxShadow: "3px 3px 8px rgba(174,184,200,0.3), -3px -3px 8px rgba(255,255,255,0.9)",
  _hover: {
    transform: "translateY(-1px)",
    boxShadow: "4px 4px 10px rgba(174,184,200,0.4), -4px -4px 10px rgba(255,255,255,1)",
    color: neumorph.accentTealDark,
  },
}
